import classnames from 'classnames/bind'
import { useState, useEffect, useRef } from 'react'
import { useTranslation } from 'next-i18next'

// Libs
import useMedia from '@/hooks/useMedia'
import { handleGtmClickViewCoupon } from '@/methods/handleGtmEvent'

// Components
import CouponOption from './component/OptionItem'
import SelectedItem from './component/SelectedItem'
import DrawerComponent from '@/components/common/Drawer'
import { TicketsData } from '@/hooks/usePromotion'

// Constants
import { GTM_LOCATION, GtmClickViewCouponText } from '@/constants/gtmEvent'

// Styles
import styles from './style.module.scss'

const cx = classnames.bind(styles)

interface CouponProps {
  className?: string
  promotionCouponData: TicketsData[]
  selectedCoupon: TicketsData | undefined
}

const Coupon = ({ className, promotionCouponData, selectedCoupon }: CouponProps) => {
  const [selectIsOpen, setSelectIsOpen] = useState(false)
  const [isDrawerOpen, setIsDrawerOpen] = useState(false)
  const selectRef = useRef<any>(null)
  const optionRef = useRef<any>(null)
  const { isDesktop } = useMedia()
  const { t } = useTranslation('')

  const handleSelectClick = () => {
    handleGtmClickViewCoupon({
      clickTextI18Key: GtmClickViewCouponText.PRODUCT_DETAIL_CHECK_COUPON,
      location: GTM_LOCATION.PRODUCT_DETAIL,
    })
    if (isDesktop) {
      toggleSelect()
    } else {
      setIsDrawerOpen(true)
    }
  }

  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      if (selectRef.current && !selectRef.current.contains(event.target) && optionRef.current && !optionRef.current.contains(event.target)) {
        setSelectIsOpen(false)
      }
    }
    document.addEventListener('click', handleOutsideClick)

    return () => {
      document.removeEventListener('click', handleOutsideClick)
    }
  }, [])
  const toggleSelect = () => {
    setSelectIsOpen(!selectIsOpen)
  }

  return (
    <div className={cx('coupon', className)}>
      <div className={cx('coupon__wrapper')}>
        {isDesktop && <div className={cx('coupon__title')}>{t('Common_Coupon')}</div>}
        <div className={cx('coupon__select')}>
          <div className={cx('coupon__select-selected')} onClick={handleSelectClick} ref={selectRef}>
            <SelectedItem selected={selectedCoupon} isOpen={selectIsOpen} />
          </div>
          {selectIsOpen && (
            <div className={cx('coupon__select-options')} ref={optionRef}>
              <div className={cx('coupon__select-options-drawer-title')}>{t('Product_Detail_Coupon_Select_Title')}</div>
              <p className={cx('coupon__select-options-footer')}>{t('Product_Detail_Coupon_Select_Description')}</p>
              <div className={cx('coupon__select-options-content')}>
                {promotionCouponData.map((item) => (
                  <CouponOption key={item.couponId} item={item} />
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
      <DrawerComponent
        open={isDrawerOpen}
        onClose={() => {
          setIsDrawerOpen(false)
        }}
        direction='bottom'
        className={cx('drawer')}
      >
        <div className={cx('coupon__select-options')}>
          <div className={cx('coupon__select-options-drawer-title')}>{t('Product_Detail_Coupon_Select_Title')}</div>
          <p className={cx('coupon__select-options-footer')}>{t('Product_Detail_Coupon_Select_Description')}</p>
          {promotionCouponData.map((item) => (
            <CouponOption key={item.couponId} item={item} />
          ))}
        </div>
      </DrawerComponent>
    </div>
  )
}
export default Coupon
